import { computed, shallowRef, ref, watch } from 'vue'
import { defineStore } from 'pinia'
import type { RattachementDTO } from '@/features/api/extranet/dto/Profil'
import * as api from '@/features/services/profil/RattachementUtilisateurServices'
import { useAppStateStore } from '@/features/application'

export const useRattachementsStore = defineStore('rattachements', () => {
  const appState = useAppStateStore()

  const canLoad = computed(() => {
    return appState.estUtilisateurAuthentifie && appState.estAuthentificationEnCours === false
  })

  const rattachements = shallowRef<RattachementDTO[] | null>(null)

  const rattachementModel = ref<string | number>('')

  async function loadRattachements() {
    if (canLoad.value) {
      rattachements.value = (await api.loadRattachements(true)) ?? []
    } else {
      rattachements.value = null
    }
  }

  loadRattachements()

  watch(() => `${canLoad.value}_${appState.contextCourant}`, loadRattachements)

  return {
    rattachements,
    rattachementModel,
  }
})
